import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryPosts } from '@wix/ambassador-blog-v3-post/http';
import { PostFieldField } from '@wix/ambassador-blog-v3-post/types';
export const fetchPublishedPosts = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  const allBlogPosts = [];
  await withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkPosts = [];
      let offset = 0;
      let hasMore = true;
      do {
        const {
          data: {
            posts,
            pagingMetadata
          }
        } = await httpClient.request(queryPosts({
          fieldsets: [PostFieldField.RICH_CONTENT],
          query: {
            filter: {
              ...(idChunk.length > 0 ? {
                id: {
                  $in: idChunk
                }
              } : {})
            },
            paging: {
              limit: COMMON_PAGE_LIMIT,
              offset
            }
          }
        }));
        chunkPosts.push(...(posts ?? []));
        offset += COMMON_PAGE_LIMIT;
        hasMore = (pagingMetadata == null ? void 0 : pagingMetadata.hasNext) ?? false;
      } while (hasMore);
      return chunkPosts;
    });
    const results = await Promise.all(chunkPromises);
    allBlogPosts.push(...results.flat());
  }, {
    errorCodesMap: {}
  });
  return allBlogPosts;
};
//# sourceMappingURL=fetch-published-posts.js.map